import type { AvailableRouterMethod } from 'nitropack';

export const useApiFetch = async (
  uri: string,
  params?: {
    method?: AvailableRouterMethod<string>;
    body?: object;
    query?: object;
    headers?: object;
  }
): Promise<any> => {
  const cfgPublic: any = useRuntimeConfig().public;

  // expira se passou 20 minutos de inatividade
  if (!uri.startsWith('/api/pwa/auth')) {
    const expiresIn = sessionStorage.getItem('expiresIn');

    if (!expiresIn || $dayjs(expiresIn).diff($dayjs(), 'minute') < 0) {
      return navigateTo('/login?expired');
    } else {
      sessionStorage.setItem(
        'expiresIn',
        $dayjs().add(cfgPublic.expiresIn, 'minute').toISOString()
      );
    }
  }

  const nuxtApp = useNuxtApp();

  const method = params?.method || 'GET';
  const body = params?.body || undefined;
  const query = params?.query || undefined;
  const headers = params?.headers || undefined;
  const token = sessionStorage.getItem('token');

  const bypass = getBypass();
  const headersCfg: any = {
    Accept: 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...headers,
    ...(bypass ? { bypass } : {}),
  };

  const res: any = await $fetch(uri, {
    onResponse({ response }) {
      const tkn = response.headers.get('token');
      if (tkn) {
        sessionStorage.setItem('token', tkn);
      }
    },
    headers: headersCfg,
    baseURL: cfgPublic.bffBase,
    method,
    body,
    query,
  });

  // Se há mensagem de sucesso/info/warning na resposta
  if (res.messages) {
    for (const message of res.messages) {
      switch (message?.type) {
        case 'error':
          nuxtApp.$toast.error(message?.text);
          break;
        case 'info':
          nuxtApp.$toast.info(message?.text);
          break;
        case 'warning':
          nuxtApp.$toast.warning(message?.text);
          break;
        default:
          nuxtApp.$toast.success(message?.text);
          break;
      }
    }
  }

  if (res.data === 'Session expired') {
    delete nuxtApp.payload.state['currentUser'];
    sessionStorage.removeItem('expiresIn');
    sessionStorage.removeItem('token');
    navigateTo('/login?logout');
    return;
  }

  return res.data;
};

const getBypass = () => {
  const route = useRoute();
  return route.query.bypass || false;
};
